// extracted by css-extract-rspack-plugin
export default {"tableLoading":"table-loading_EY3XK"};